import { css } from 'lit'
import { visuallyHidden } from './mixins'
import variables from './variables.js'
import typography from './typography.js'
import accessibility from './accessibility.js'

export default css`
  @font-face {
    font-family: 'NBAkademieStd';
    src: url('fonts/NBAkademieStd-Regular.ttf') format('ttf');
    font-weight: 300;
    font-display: swap;
  }

  @font-face {
    font-family: 'NBAkademieStd';
    src: url('fonts/NBAkademieStd-Medium.ttf') format('ttf');
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: 'InputMonoCondensed';
    src: url('fonts/InputMonoCondensed-Light.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'InputMonoCondensed';
    src: url('fonts/InputMonoCondensed-Medium.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'InputMonoCondensed';
    src: url('fonts/InputMonoCondensed-MediumItalic.ttf') format('truetype');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'InputMonoCondensed';
    src: url('fonts/InputMonoCondensed-LightItalic.ttf') format('truetype');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Nimbus Sans D';
    src: url('fonts/NimbusSanD-UltLig.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  body {
    font: var(--hh-body-font);

    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  ${typography}

  ${visuallyHidden}

  ${variables}

  ${accessibility}
`
